var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.0031C15 12.3365 13.6667 11.0031 12 11.0031C10.3333 11.0031 9 12.3365 9 14.0031V19.0031H7C5.77193 19.0031 5 18.2312 5 17.0031V11.2488C5 10.6347 5.15789 10.2488 5.57895 9.82771L10.5789 4.82771C11.4737 3.95052 12.5263 3.95052 13.4211 4.82771L18.4211 9.82771C18.8421 10.2488 19 10.6347 19 11.2488V17.0031C19 18.2312 18.2281 19.0031 17 19.0031H15V14.0031ZM13 14.0031V21.0031H17C19.2105 21.0031 21 19.2137 21 17.0031V11.2488C21 10.1786 20.5789 9.16104 19.8246 8.4242L14.8246 3.4242C13.2632 1.84525 10.7368 1.84525 9.17544 3.4242L4.17544 8.4242C3.42105 9.16104 3 10.1786 3 11.2488V17.0031C3 19.2137 4.78947 21.0031 7 21.0031H11V14.0031C11 13.3189 11.3158 13.0031 12 13.0031C12.6842 13.0031 13 13.3189 13 14.0031ZM14 19.0031H10V21.0031H14V19.0031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOutlined);
export default __webpack_public_path__ + "static/media/home_outlined.c0ad2497.svg";
export { ForwardRef as ReactComponent };